(function () {
    'use strict';

    angular
        .module('directives.govSyncHeight', [])
        .directive('govSyncHeight', directive);
        
    directive.$inject = [];

    /**
     * Directive used to sync the height of multiple items as the digest cycles finish.
     * Each time an item in the cycle changes, the heights of all elems using the directive
     * with the same key (e.g. gov-sync-height="key") are checked and all the smaller elems
     * add bottom margin to cover the dif with the tallest one.
     */
    function directive() {
        return {
            link: function(scope, elem, attr) {
                var key = attr.govSyncHeight,
                    elemIndex = attr.dataGovSyncIndex;

                if (!scope[key]) {
                    scope[key] = {};
                }

                if (!elemIndex) {
                    elemIndex = Object.keys(scope[key]).length;
                    scope[key][elemIndex] = elem.height();

                    elem.attr('data-gov-sync-index', elemIndex);
                }

                scope.$watch(function() {
                    var elemHeight = elem.height(),
                        maxHeight = 0;

                    scope[key][elemIndex] = elemHeight;

                    for (var i = 0; i < Object.keys(scope[key]).length; ++i) {
                        if (scope[key][i] > maxHeight) {
                            maxHeight = scope[key][i];
                        }
                    }
                    if (maxHeight > elemHeight) {
                        elem.attr('style', 'margin-bottom: ' + (maxHeight - elemHeight) + 'px !important');
                    } else {
                        elem.attr('style', 'margin-bottom: ' + '0 !important');
                    }
                });
            }
        };
    }
})();